import PropertyFormContainer from './PropertyFormContainer';

export default PropertyFormContainer;
